import React from "react";
import { useState, useEffect, useCallback, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import LoadingOverlay from "react-loading-overlay-ts";
import { catlistData, setisfirsttime } from "../../actions/index";
import { actlistData } from "../../actions/index";
import { BASE_PATH } from "../../constants/Global";
import Modal from "react-bootstrap/Modal"; // <-- you need react-bootstrap
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { encode } from "base-64";
import { getRefresh } from "../../actions/index";
import { confirmAlert } from "react-confirm-alert";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import {
  getDatabase,
  ref,
  remove,
  onValue,
  set,
  update,
} from "firebase/database";
import { useDrag, useDrop } from "react-dnd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons";
import { faTableCellsLarge } from "@fortawesome/free-solid-svg-icons";
import { FirebaseContext } from "../../FirebaseContext";
import { faUserPlus } from "@fortawesome/free-solid-svg-icons";
const ItemType = "CATEGORY";

function Category(match) {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [isActive, setActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const getpageData = useSelector((state) => state.setcatlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const aid = localStorage.getItem("auction_id");
  const refresh = useSelector((state) => state.setRefresh);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [islist, setislist] = useState(false);
  const [path, setpath] = useState();
  const updtoken = useSelector((state) => state.updtoken);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const [playerInput, setPlayerInput] = useState("");
  const { upddata } = useContext(FirebaseContext);
  const history = useHistory({ forceRefresh: true });
  const [selcat, setselcat] = useState("");
  const [currentCategoryId, setCurrentCategoryId] = useState(null);

  const handlePlayerSubmit = async (cid, rawInput) => {
    console.log("----cid", cid);

    const playerIds = rawInput
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    if (playerIds.length === 0) {
      alert("Please enter at least one player ID.");
      return;
    }
    try {
      // setIsLoading?.(true); // Agar loading state hai
      const formData = new FormData();
      formData.append("aid", aid);
      formData.append("selcat", cid);
      formData.append("plist", playerIds.join(","));
      const resp = await DataService.addPlayersToCategory(formData);

      if (resp.data.success) {
        toast.success("Player category updated successfully!");
      } else {
        toast.error(resp.data.message || "Error updating player category");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to update player category");
    } finally {
      setShowModal(false);
      setPlayerInput("");
      setCurrentCategoryId(null);
      // setIsLoading?.(false);
    }
  };

  const fetchData = async () => {
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listCategory({ aid: aid }, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;
          //  console.log(responsedata);
          setData(responsedata);
          dispatch(catlistData({ responsedata }));

          if (refresh == 1) {
            dispatch(getRefresh(0));
          }
        }

        setActive(false);
      })
      .catch(() => {
        //  console.log('Not valid')
        setActive(false);
      });
  };

  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };
  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            authorization: JSON.stringify([
              { cid: cid, aid: aid, token: loginuser["token"] },
            ]),
          },
        };

        await DataService.deleteCategory({ ctid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;

            if (response.success == true) {
              const db = getDatabase();

              set(ref(db, "map/info/" + aid), {
                type: "3",
                upd: "3",
                id: vl,
                detail: "",
                tkn: updtoken,
              });
              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });
              const updatedList = (data?.list || []).filter(
                (ele) => ele.cid != vl
              );
              // Update component state immutably
              setData({ path: data?.path, aid: data?.aid, list: updatedList });
              // Sync Redux cache immutably
              dispatch(
                catlistData({
                  responsedata: {
                    path: data?.path,
                    aid: data?.aid,
                    list: updatedList,
                  },
                })
              );
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }

            setActive(false);
          })
          .catch(() => {
            //  console.log('Not valid')
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [aid, cid, dispatch, loginuser, updtoken, data]
  );
  const firechange = (datasnap) => {
    //  console.log("firechange")
    //  console.log(getpageData)
    if (datasnap.type == "3" && datasnap.upd == "1") {
      if (getpageData != 0) {
        //  console.log("lol ")
        let responsedata = {};
        // var newdata = {
        //   'tmid': datasnap.detail.tmid,
        //   'logo': datasnap.detail.logo,
        //   'name': datasnap.detail.name,
        //   'sname': datasnap.detail.srtname,
        //   'srtkey': datasnap.detail.srtkey,

        // }
        //  console.log("lol2 ")
        // //  console.log(newdata)

        responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: [datasnap.detail, ...getpageData.responsedata.list],
          },
        };
        //  console.log(responsedata)
        setData(responsedata.responsedata);

        dispatch(catlistData(responsedata));
      }
    }
    if (datasnap.type == "3" && datasnap.upd == "2") {
      //  console.log("firechange edit")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele, ind) => {
          if (ele.cid == datasnap.id) {
            ele.cname = datasnap.detail.cname;
            ele.clr = datasnap.detail.clr;
            ele.cathibid = datasnap.detail.cathibid;
            ele.hibid = datasnap.detail.hibid;
            ele.incrs = datasnap.detail.incrs;
            ele.ismin = datasnap.detail.ismin;
            ele.mbid = datasnap.detail.mbid;
            ele.minplno = datasnap.detail.minplno;
            ele.plno = datasnap.detail.plno;
            ele.resv = datasnap.detail.resv;
            ele.mincr = datasnap.detail.mincr;
          }

          return ele;
        });
        //  console.log(updateitem)
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedata);
        dispatch(catlistData(responsedata));
      }
    }
    if (datasnap.type == "3" && datasnap.upd == "3") {
      //  console.log("firechange del")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele, ind) => {
          return ele.cid != datasnap.id;
        });
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedata);

        dispatch(catlistData(responsedata));
      }
    }
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter(
          (ele) => ele.aid != datasnap.id
        );

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + "my-auction");
    }
    if (
      (datasnap.type == "1" && datasnap.upd == "4") ||
      (datasnap.type == "3" && datasnap.upd == "4")
    ) {
      setData(getpageData.responsedata);
    }
  };
  useEffect(() => {
    localStorage.removeItem("isFirstMount");

    if (refresh == 1) {
      fetchData(0);
    }

    if (getpageData == 0) {
      fetchData(0);
    } else {
      if (getpageData.responsedata.aid == aid) {
        setData(getpageData.responsedata);
      } else {
        let responsedata = getpageData.responsedata;
        responsedata.list = [];
        setData(responsedata);
        fetchData(0);
      }
    }
  }, [refresh]);
  useEffect(() => {
    //  console.log("my upddata");
    //  console.log(upddata);
    if (upddata !== null) {
      //  console.log(upddata)
      //  console.log(isfirsttime)
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "3") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);
  const moveCat = async (fromIndex, toIndex) => {
    //  console.log(fromIndex)

    const updatedOrder = [...data.list];
    const [moveCat] = updatedOrder.splice(fromIndex, 1);
    updatedOrder.splice(toIndex, 0, moveCat);
    // setdummy('77'+fromIndex)

    // dispatch(teamlistData(responsedata));
    setTimeout(
      () =>
        setData({
          // path: path,
          aid: aid,
          list: updatedOrder,
        }),
      0
    );
    //  console.log("updatedOrder")
    var torder = "";
    updatedOrder.map((ele) => {
      if (torder == "") {
        torder += ele.cid;
      } else {
        torder += "," + ele.cid;
      }
    });
    //  console.log(updatedOrder)
    //  console.log(torder)
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };
    //  console.log(aid)
    //  console.log(torder)
    await DataService.setcatorder({ aid: aid, ids: torder }, hdr).then(
      (res) => {
        let response = res.data;
        //  console.log(response)
        if (response.success == true) {
          let responsedata = {
            responsedata: {
              path: getpageData.responsedata.path,
              aid: aid,
              list: updatedOrder,
            },
          };
          //  console.log(responsedata.responsedata)
          setData(responsedata.responsedata);
          dispatch(catlistData(responsedata));
          // setData(neworder);
          // dispatch(catlistData({ neworder }));

          //  console.log("order updated")
        }
      }
    );
    // setTeamOrder(updatedOrder);
  };

  const Cat = ({ cat, index }) => {
    // //  console.log('index')
    // //  console.log(team)
    // //  console.log(index)
    const [, drag] = useDrag({
      type: ItemType,
      item: { index },
    });

    const [, drop] = useDrop({
      accept: ItemType,
      hover: (draggedItem) => {
        if (draggedItem.index !== index) {
          moveCat(draggedItem.index, index);

          draggedItem.index = index;
        }
      },
    });

    return (
      <li
        className="liview"
        ref={(node) => drag(drop(node))}
        style={{ cursor: "move" }}
      >
        <div className="liflex">
          <div className="liinner">
            <strong>{cat.cname}</strong>
          </div>
          <div className="liinner">
            <span>Plno : </span>
            {cat.plno != 0
              ? cat.plno + (cat.minplno != 0 ? "/" + cat.minplno : "")
              : cat.minplno != 0
              ? cat.minplno
              : "--"}
          </div>
        </div>
        <div className="liflex">
          <div className="liinner">
            <span>Base : </span>
            {cat.mbid == 0 ? "--" : cat.mbid}{" "}
          </div>
          <div className="liinner">
            <span>Incr : </span>
            {cat.incrs == 0 ? "--" : cat.incrs}
          </div>
          <div className="liinner">
            <span>Resv : </span>
            {cat.resv == 0 ? "--" : cat.resv}
          </div>
        </div>
        <div className="liflex">
          <div className="liinner">
            <span>H-bid: </span>
            {cat.hibid == 0 ? "--" : cat.hibid}
          </div>
          <div className="liinner">
            <span>Cat-bid : </span>
            {cat.cathibid == 0 ? "--" : cat.cathibid}
          </div>
          <div className="liinner licust">
            <div>
              <Link
                style={{
                  color: "#186cc2",
                  padding: "0 18px",
                }}
                to={"edit-auction-category/" + encode(cat.cid)}
              >
                <AiIcons.AiOutlineEdit
                  size={"20px"}
                  style={{ color: "green" }}
                />
              </Link>
            </div>
            <div>
              <button
                type="button"
                onClick={() => deldata(cat.cid)}
                style={{
                  background: "transparent",
                  border: "none",
                  padding: 0,
                  color: "red",
                  cursor: "pointer",
                }}
                aria-label="Delete category"
              >
                <AiIcons.AiOutlineDelete size={"20px"} />
              </button>
            </div>
          </div>
        </div>
      </li>
      // // <li ref={(node) => drag(drop(node))} style={{ cursor: 'move' }}>
      // //   <strong>{team.name}</strong> - ID: {team.id}
      // // </li>
      // <div className="teamcard" ref={(node) => drag(drop(node))} style={{ cursor: 'move' }}>
      //   <div className="tdetail">
      //     <div className="timg"><img src={teamdefaultLogo} alt="" /></div>
      //     <div className="tdetailsub">
      //       <p><b>{team.name}</b></p>
      //       <p>Short-name : <b>{team.sname} </b>&nbsp;&nbsp;&nbsp;Short-key : <b>{team.srtkey}</b></p>
      //     </div>
      //   </div>
      //   <div className="tbuttons">
      //     <Link
      //       style={{
      //         color: "#186cc2",
      //         padding: "0 18px",
      //       }}
      //     // onClick={() => setauction(dt.aid, dt.aname, dt.atm)}
      //     // to={"/edit-auction-team/" +
      //     //   encode(dt.tid)}
      //     >
      //       <AiIcons.AiOutlineEdit
      //         size={"20px"}
      //         style={{ color: "green" }}
      //       />
      //     </Link>
      //     <Link
      //       onClick={() => deldata(dt.tid)}
      //       style={{ color: "red" }}
      //     >
      //       <AiIcons.AiOutlineDelete size={"20px"} />
      //     </Link>
      //   </div>
      // </div>
    );
  };

  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        <div>
          <Navigationtitle data={match} />
          <div id="top-categories" className="top-cat-area  bottom-less">
            <div className="container-fluid padding-left-0px">
              <section
                id="advisor"
                className="advisor-area default-padding bottom-less"
              >
                <div className="container-fluid">
                  <div className="row">
                    <button
                      onClick={() => setislist(!islist)}
                      className="listteam mydesbtn"
                    >
                      {!islist ? (
                        <FontAwesomeIcon icon={faList} />
                      ) : (
                        <FontAwesomeIcon icon={faTableCellsLarge} />
                      )}
                    </button>
                    {!islist ? (
                      <div className="advisor-items text-center text-light">
                        {data != "" ? (
                          data.list?.map((dt, key) => {
                            return (
                              <div className="col-md-3 col-sm-6 col-xs-12 single-item catitem">
                                <div className="advisor-item">
                                  <div className="info-box catbox">
                                    <div className="info-title catitemsub">
                                      <h4>{dt.cname}</h4>
                                      <div className="catinfocontainer">
                                        <div className="row1">
                                          <div>
                                            <span className="mylbl">
                                              Player
                                            </span>{" "}
                                            :{" "}
                                            {dt.plno != 0
                                              ? dt.plno +
                                                (dt.minplno != 0
                                                  ? "/" + dt.minplno
                                                  : "")
                                              : dt.minplno != 0
                                              ? dt.minplno
                                              : "--"}
                                          </div>
                                          <div>
                                            <span className="mylbl">
                                              {" "}
                                              Base{" "}
                                            </span>
                                            : {dt.mbid == 0 ? "--" : dt.mbid}
                                          </div>
                                        </div>
                                        <div className="row1">
                                          <div>
                                            <span className="mylbl">
                                              {" "}
                                              Incr{" "}
                                            </span>{" "}
                                            : {dt.incrs == 0 ? "--" : dt.incrs}
                                          </div>
                                          <div>
                                            <span className="mylbl">
                                              {" "}
                                              Resv{" "}
                                            </span>
                                            : {dt.resv == 0 ? "--" : dt.resv}
                                          </div>
                                        </div>
                                        <div className="row1">
                                          <div>
                                            <span className="mylbl">
                                              {" "}
                                              H-Bid{" "}
                                            </span>{" "}
                                            : {dt.hibid == 0 ? "--" : dt.hibid}
                                          </div>
                                          <div>
                                            <span className="mylbl">
                                              {" "}
                                              Cat-Bid{" "}
                                            </span>{" "}
                                            :{" "}
                                            {dt.cathibid == 0
                                              ? "--"
                                              : dt.cathibid}
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div className="social">
                                    <ul>
                                      <li className="facebook">
                                        <Link to={"/edit-auction-category/" + encode(dt.cid)}>
                                          <AiIcons.AiFillEdit></AiIcons.AiFillEdit>
                                        </Link>
                                      </li>
                                      <li className="pinterest">
                                        <Link to={"#"} onClick={() => deldata(dt.cid)}>
                                          <AiIcons.AiFillDelete></AiIcons.AiFillDelete>
                                        </Link>
                                      </li>
                                    </ul>
                                  </div> */}
                                      <div className="row catbottomrow">
                                        <div className="col-md-12 text-align auccatbottom">
                                          <div className="catlbl2">
                                            {/* ----- NEW: Add Players ----- */}
                                            <div>
                                              <button
                                                type="button"
                                                onClick={() => {
                                                  setCurrentCategoryId(dt.cid); // ← Save current category ID
                                                  setShowModal(true);
                                                }}
                                                style={{
                                                  background: "transparent",
                                                  border: "none",
                                                  padding: 0,
                                                  color: "#186cc2",
                                                  cursor: "pointer",
                                                }}
                                                aria-label="Add main players"
                                              >
                                                <FontAwesomeIcon
                                                  icon={faUserPlus}
                                                  size="lg"
                                                />
                                              </button>
                                            </div>
                                            <div>
                                              <Link
                                                style={{
                                                  color: "#186cc2",
                                                  padding: "0 18px",
                                                }}
                                                to={
                                                  "edit-auction-category/" +
                                                  encode(dt.cid)
                                                }
                                              >
                                                <AiIcons.AiOutlineEdit
                                                  size={"20px"}
                                                  style={{ color: "green" }}
                                                />
                                              </Link>
                                            </div>
                                            <div>
                                              <button
                                                type="button"
                                                onClick={() => deldata(dt.cid)}
                                                style={{
                                                  background: "transparent",
                                                  border: "none",
                                                  padding: 0,
                                                  color: "red",
                                                  cursor: "pointer",
                                                }}
                                                aria-label="Delete category"
                                              >
                                                <AiIcons.AiOutlineDelete
                                                  size={"20px"}
                                                />
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {showModal && (
                                  <div
                                    style={{
                                      position: "fixed",
                                      top: 0,
                                      left: 0,
                                      width: "100vw",
                                      height: "100vh",
                                      backgroundColor: "rgba(0, 0, 0, 0.85)",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      zIndex: 9999,
                                      backdropFilter: "blur(5px)",
                                      animation:
                                        "fadeIn 0.3s ease-out forwards",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "white",
                                        width: "90%",
                                        maxWidth: "480px",
                                        borderRadius: "16px",
                                        boxShadow:
                                          "0 25px 50px rgba(0, 0, 0, 0.3)",
                                        padding: "32px",
                                        position: "relative",
                                        animation:
                                          "slideUp 0.4s ease-out forwards",
                                      }}
                                    >
                                      {/* Header */}
                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          marginBottom: "24px",
                                        }}
                                      >
                                        <h2
                                          style={{
                                            fontSize: "22px",
                                            fontWeight: "bold",
                                            color: "#1f2937",
                                            margin: 0,
                                          }}
                                        >
                                          Main Players
                                        </h2>
                                        <button
                                          onClick={() => setShowModal(false)}
                                          style={{
                                            background: "none",
                                            border: "none",
                                            fontSize: "28px",
                                            color: "#6b7280",
                                            cursor: "pointer",
                                            width: "36px",
                                            height: "36px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            borderRadius: "50%",
                                            transition: "all 0.2s",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.target.style.backgroundColor =
                                              "#f3f4f6";
                                            e.target.style.color = "#374151";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor =
                                              "transparent";
                                            e.target.style.color = "#6b7280";
                                          }}
                                        >
                                          {/* <AiOutlineClose /> */}
                                        </button>
                                      </div>

                                      {/* Form Body */}
                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          gap: "16px",
                                        }}
                                      >
                                        <div>
                                          <label
                                            style={{
                                              display: "block",
                                              fontWeight: "500",
                                              color: "#374151",
                                              fontSize: "15px",
                                              marginBottom: "8px",
                                            }}
                                          >
                                            Enter Player IDs (comma-separated)
                                          </label>
                                          <textarea
                                            rows={4}
                                            placeholder="e.g. 123, 456, 789"
                                            value={playerInput}
                                            onChange={(e) =>
                                              setPlayerInput(e.target.value)
                                            }
                                            style={{
                                              width: "100%",
                                              padding: "12px 14px",
                                              borderRadius: "10px",
                                              border: "1.5px solid #d1d5db",
                                              fontSize: "15px",
                                              resize: "none",
                                              outline: "none",
                                              transition: "border 0.2s",
                                            }}
                                            onFocus={(e) =>
                                              (e.target.style.borderColor =
                                                "#3b82f6")
                                            }
                                            onBlur={(e) =>
                                              (e.target.style.borderColor =
                                                "#d1d5db")
                                            }
                                          />
                                          <p
                                            style={{
                                              fontSize: "13px",
                                              color: "#6b7280",
                                              marginTop: "6px",
                                              marginLeft: "2px",
                                            }}
                                          >
                                            Separate multiple IDs with commas
                                          </p>
                                        </div>
                                      </div>

                                      {/* Footer Buttons */}
                                      <div
                                        style={{
                                          marginTop: "28px",
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          gap: "12px",
                                        }}
                                      >
                                        <button
                                          onClick={() => setShowModal(false)}
                                          style={{
                                            padding: "10px 20px",
                                            backgroundColor: "transparent",
                                            color: "#6b7280",
                                            border: "1.5px solid #d1d5db",
                                            borderRadius: "10px",
                                            fontWeight: "500",
                                            fontSize: "15px",
                                            cursor: "pointer",
                                            transition: "all 0.2s",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.target.style.backgroundColor =
                                              "#f9fafb";
                                            e.target.style.borderColor =
                                              "#9ca3af";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.backgroundColor =
                                              "transparent";
                                            e.target.style.borderColor =
                                              "#d1d5db";
                                          }}
                                        >
                                          Cancel
                                        </button>

                                        <button
                                          onClick={() => {
                                            handlePlayerSubmit(
                                              currentCategoryId,
                                              playerInput
                                            );
                                            // Optional: close modal after submit if needed
                                            // setShowModal(false);
                                          }}
                                          style={{
                                            padding: "10px 24px",
                                            backgroundColor: "#3b82f6",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "10px",
                                            fontWeight: "600",
                                            fontSize: "15px",
                                            cursor: "pointer",
                                            transition: "background 0.2s",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.target.style.backgroundColor =
                                              "#2563eb")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.target.style.backgroundColor =
                                              "#3b82f6")
                                          }
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <NotFound data={isActive} />
                        )}
                      </div>
                    ) : (
                      <>
                        <div className="teamcontainer">
                          {data != "" &&
                            data.list.map((cat, index) => (
                              <Cat key={cat.cid} cat={cat} index={index} />
                            ))}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default Category;
